import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { PaymentScheduleTabName } from '../../../models/_enum-collections';
import { DownloadPaymentScheduleCSV } from '../../../models/download-payment-schedule-csv.model';
import { PaymentBatchList } from '../../../models/payment-batch-list.model';
import { SettingsService } from '../../common/settings.service';
import { PaymentScheduleService } from '../../services/payment-schedule.service';
import { PaymentBatchTableComponent } from '../../shared/payment-batch-table/payment-batch-table.component';

@Component({
  selector: 'app-payment-schedule-milestone1',
  templateUrl: './payment-schedule-milestone1.component.html',
  styleUrls: ['./payment-schedule-milestone1.component.scss'],
  standalone: true,
  imports: [PaymentBatchTableComponent]
})
export class PaymentScheduleMilestone1Component implements OnInit {
  @Input() selectedProgramOption!: string;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  isSpin = false;
  tabName!: PaymentScheduleTabName;

  @ViewChild('dt', { static: false }) dt!: Table;

  paymentBatchList: PaymentBatchList[] = [];
  pscols!: any[];
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  downloadCSV: DownloadPaymentScheduleCSV[] = [];

  constructor(
    private pmService: PaymentScheduleService,
    public settings: SettingsService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.tabName = PaymentScheduleTabName.Milestone1;
    this.getDownloadCSVFile();
  }

  getDownloadCSVFile() {
    this.pmService.getDownloadCSVFile().subscribe(downloadReport => {
      this.downloadCSV = downloadReport;
    });
  }

  exportCSV() {
    this.isSpin = true;
    const fileName = this.downloadCSV[0].fileName;
    const headers = new HttpHeaders();
    const downloadUrl =
      this.settings.baseUrl +
      'api/PaymentSchedule/DownloadFile/' +
      'ADD' +
      '/FileName/' +
      fileName;

    this.http
      .get(downloadUrl, {
        headers,
        responseType: 'blob'
      })
      .subscribe(() => {
        this.isSpin = false;
      });
  }
}
